<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>联系人关联实体</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增关联实体</el-button>
                <div class="main_header_btns">
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="entity_contact"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <span> {{ scope.row[item.prop] }} </span>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid, scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="45%" v-dialogDrag :before-close="beforeClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                <el-form-item label="实体类型：" prop="entity_type">
                    <el-select
                        filterable
                        v-model="ruleForm.entity_type"
                        clearable
                        placeholder="请选择实体类型"
                        size="mini"
                        @change="typeChange"
                    >
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否为主联系人：" prop="main">
                    <div style="width: 280px">
                        <el-switch v-model="ruleForm.main" active-color="#13ce66" inactive-color="#cccccc" @change="switchChange">
                        </el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="账户：" prop="entity_name" v-if="typeLable == 'account'">
                    <el-select
                        v-model="ruleForm.entity_name"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入账户名称搜索"
                        :remote-method="remoteMethod"
                        :loading="parentLoading"
                        size="mini"
                        clearable
                        @change="parentChange"
                    >
                        <el-option v-for="item in parentOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作方：" prop="entity_name" v-if="typeLable == 'partner'">
                    <el-select
                        v-model="ruleForm.entity_name"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入合作方搜索"
                        :remote-method="remoteMain"
                        :loading="mainLoading"
                        size="mini"
                        clearable
                        @change="mainChange"
                    >
                        <el-option v-for="item in mainOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAddData('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'contactUpComponent',
    data() {
        return {
            draggable: {
                data_name: 'entity_contact'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            dialogTitle: '',
            mainOptions: [],
            typeOptions: [
                //职务列表
                {
                    value: 'account',
                    label: '账户'
                },
                {
                    value: 'partner',
                    label: '合作方'
                }
            ],
            dialogVisible: false,
            parentOptions: [],
            mainOptions: [],
            parentLoading: false,
            mainLoading: false,
            rules: {
                main: [
                    {
                        required: true,
                        message: '请选择是否为主联系人',
                        trigger: 'change'
                    }
                ],
                entity_type: [{ required: true, message: '请选择实体类型', trigger: 'blur' }],
                entity_name: [{ required: true, message: '请输入选择', trigger: 'blur' }]
            },
            //基本信息内表单验证
            ruleForm: {
                entity_name: '',
                entity_type: '',
                main: false,
                entity_rid: ''
            },
            typeLable: '', //类型
            switchType: '2',
            dataType: '',
            lineId: '',
            contact_rid: '',
            partner_id: '',
            account_rid: '',
            partner_name: '',
            partner_name: '',
            postList1: {},
            entity_type: '',
            entity_rid: ''
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.contact_rid) {
                        this.contact_rid = newValue.params.contact_rid;
                        this.budget_group__show = false;
                        this.getList(0); //获取列表
                    } else {
                        this.contact_rid = '';
                        this.budget_group__show = true;
                    }
                    if (newValue.params.partner_id) {
                        this.entity_type = 'partner';
                        this.entity_rid = newValue.params.partner_id;
                        this.partner_name = newValue.params.partner_name;
                        this.getList(0); //获取列表
                    } else {
                        this.entity_type = '';
                        this.entity_rid = '';
                        this.partner_name = '';
                    }
                    if (newValue.params.account_rid) {
                        this.entity_type = 'account';
                        this.entity_rid = newValue.params.account_rid;
                        this.partner_name = newValue.params.partner_name;
                        this.getList(0); //获取列表
                    } else {
                        this.entity_type = '';
                        this.entity_rid = '';
                        this.partner_name = '';
                    }
                }
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['contactUp_params']) {
                this.page = paramsList['contactUp_params'].page;
                this.row = paramsList['contactUp_params'].row;
                this.contact_rid = paramsList['contactUp_params'].contact_rid;
                // this.data_name = paramsList['contactUp_params'].data_name;
                // this.sort = paramsList['contactUp_params'].sort;
                this.entity_type = paramsList['contactUp_params'].entity_type;
                this.entity_rid = paramsList['contactUp_params'].entity_rid;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        beforeClose() {
            this.dialogVisible = false;
            this.ruleForm = {
                entity_name: '',
                entity_type: '',
                main: false,
                entity_rid: ''
            };
            this.$refs['ruleForm'].resetFields();
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('entity_contact', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).entity_contact;
        },
        //前往编辑页面
        editDetails(id, row) {
            this.dialogTitle = '修改';
            this.dialogVisible = true;
            this.dataType = '1';
            this.lineId = id;
            this.ruleForm.entity_name = row.entity_name;
            this.ruleForm.entity_type = row.entity_type;
            this.typeLable = row.entity_type;
            this.ruleForm.entity_rid = row.entity_rid;
            this.switchType = row.main;
            if (row.main == 1) {
                this.ruleForm.main = true;
            } else {
                this.ruleForm.main = false;
            }
        },
        //确定提交
        submitAddData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.dataType == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAdd(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //修改
        submitEditData() {
            let params = {
                entity_type: this.ruleForm.entity_type,
                entity_rid: this.ruleForm.entity_rid,
                contact_rid: this.contact_rid,
                main: this.switchType,
                rid: this.lineId
            };
            this.$api
                .entityContactUpdate(params)
                .then((res) => {
                    this.dialogVisible = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                    }
                })
                .catch((error) => {
                    this.dialogVisible = false;
                    
                });
        },
        //新增
        submitAdd() {
            let params = {
                entity_type: this.ruleForm.entity_type,
                entity_rid: this.ruleForm.entity_rid,
                contact_rid: this.contact_rid,
                main: this.switchType
            };
            this.$api
                .entityContactInsert(params)
                .then((res) => {
                    this.dialogVisible = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                    }
                })
                .catch((error) => {
                    this.dialogVisible = false;
                    
                });
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.parentOptions = res.data;
                            this.parentLoading = false;
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //合作方远程搜索方法
        remoteMain(query) {
            if (query !== '') {
                this.mainLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.mainOptions = res.data;
                            this.mainLoading = false;
                        } else {
                            this.mainOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.mainLoading = false;
                this.mainOptions = [];
            }
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .entityContactDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0); //获取列表
                            }
                        })
                        .catch((error) => {
                            
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        //账户名称联动框改变
        parentChange(value) {
            this.ruleForm.entity_rid = value;
        },
        //主联系人联动框改变
        mainChange(value) {
            this.ruleForm.entity_rid = value;
        },
        switchChange(value) {
            if (value) {
                this.switchType = '1';
            } else {
                this.switchType = '2';
            }
        },
        //类型选择
        typeChange(value) {
            this.typeLable = value;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contactUp_params']) {
                    newParamsList['contactUp_params'].data_name = val.prop;
                    newParamsList['contactUp_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //新增
        addAcount() {
            if (this.postList.params) {
                if (this.postList.params.partner_id) {
                    this.$router.push({
                        path: '/contactEdit',
                        query: {
                            type: 4,
                            entity_type: 'partner',
                            entity_rid: this.postList.params.partner_id,
                            partner_name: this.postList.params.partner_name,
                            partner_id: this.postList.params.partner_id
                        }
                    });
                } else if (this.postList.params.account_rid) {
                    this.$router.push({
                        path: '/contactEdit',
                        query: {
                            type: 4,
                            entity_type: 'account',
                            entity_rid: this.postList.params.account_rid,
                            partner_name: this.postList.params.partner_name,
                            account_rid: this.postList.params.account_rid
                        }
                    });
                } else if (this.postList.params.contact_rid) {
                    this.dialogVisible = true;
                    this.dataType == '2';
                    this.dialogTitle = '新增';
                }
            } else {
                this.dialogVisible = true;
                this.dataType == '2';
                this.dialogTitle = '新增';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                contact_rid: this.contact_rid,
                entity_type: this.entity_type,
                entity_rid: this.entity_rid,
                sort: [this.data_name, this.sort],
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['contactUp_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .entityContactLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['contactUp_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contactUp_params']) {
                    newParamsList['contactUp_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        contact_rid: this.contact_rid,
                        entity_type: this.entity_type,
                        entity_rid: this.entity_rid,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['contactUp_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contactUp_params']) {
                    newParamsList['contactUp_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        contact_rid: this.contact_rid,
                        entity_type: this.entity_type,
                        entity_rid: this.entity_rid,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['contactUp_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
        width: 50%;
        .el-input {
            width: 170px;
        }
        .el-select {
            width: 200px;
        }
    }
}
</style>